import {FC, useContext, useEffect} from 'react';
import clsx from 'clsx';
import {format} from 'date-fns';
import DateSelectContext from '../../../context';
import {selector} from '../../../utils';

export type DateSelectDateProps = {
    cell?: number;
    currentFocus?: string;
    date: Date;
    isSelected?: boolean;
    isThisMonth?: boolean;
    isToday?: boolean;
    onClick?: (value: Date) => void;
    setCurrentFocus: (value: string) => void;
};

const DateSelectDate: FC<DateSelectDateProps> = (props) => {
    const {
        cell,
        currentFocus,
        date,
        isSelected,
        isThisMonth,
        isToday,
        onClick,
        setCurrentFocus,
    } = props;

    const {id} = useContext(DateSelectContext);

    const dateId = cell === undefined ? '' : selector.date(id, cell);

    useEffect(() => {
        if (!currentFocus && isSelected) {
            setCurrentFocus(dateId);
        }
    }, [cell, currentFocus, dateId, isSelected, setCurrentFocus]);

    const isDisabled = !onClick;

    return (
        <td className="text-center text-sm">
            <button
                aria-checked={isSelected && !isDisabled}
                aria-hidden={!isThisMonth}
                aria-label={format(date, 'yyyy-MM-dd')}
                className={clsx(
                    'h-8 w-[2.125rem] rounded border-none outline-none relative',
                    isSelected
                        ? 'bg-green-300'
                        : 'hover:bg-grey-200 focus:bg-grey-400 active:bg-grey-400',
                    isDisabled &&
                        !isSelected &&
                        'text-light-disabled cursor-not-allowed',
                    !isThisMonth &&
                        !isSelected &&
                        !isDisabled &&
                        'text-light-secondary',
                    isToday && !isSelected && 'text-green-700',
                )}
                disabled={!onClick}
                id={dateId}
                onClick={onClick ? () => onClick(date) : undefined}
                role="checkbox"
                tabIndex={onClick ? 0 : -1}
                type="button"
            >
                {date.getDate()}
                {isToday && isThisMonth && (
                    <div className="absolute top-1 left-0 w-full">
                        <div className="w-1 h-1 rounded-full mx-auto bg-green-700" />
                    </div>
                )}
            </button>
        </td>
    );
};

export default DateSelectDate;
